<div class="container section__autogestion h-full">
  <div class="wrapper">
    <ng-container *ngIf="!stepRequest">
      <div class="sectionContainer fadeinright animation-duration-200" >
        <article>
          <app-sales-breadcrumbs [routes]="routesBreadcrumbs"></app-sales-breadcrumbs>
          <div class="mainInfo">
            <h1>Buscar solicitud</h1>
            <p>
              Selecciona la manera de continuar la gestión del cliente.
            </p>
          </div>

          <div class="backgroundArrow">
            <div class="arrowSvg">
              <svg width="55" height="39" viewBox="0 0 55 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g opacity="0.5">
                  <path d="M29.4555 16.4348L18.4474 4.89504C16.9489 3.32418 14.4589 3.27616 12.8745 4.78756L1.23526 15.8906C-0.349133 17.402 -0.418519 19.8915 1.07997 21.4624L12.0881 33.0021C13.5866 34.573 16.0766 34.621 17.661 33.1096L29.3002 22.0066C30.8846 20.4952 30.954 18.0057 29.4555 16.4348ZM16.3354 31.72C15.5432 32.4757 14.2389 32.4505 13.4897 31.6651L2.48155 20.1253C1.73231 19.3399 1.76865 18.0359 2.56085 17.2802L14.2001 6.17717C14.9923 5.42146 16.2966 5.44662 17.0458 6.23205L28.054 17.7718C28.8032 18.5572 28.7669 19.8613 27.9747 20.617L16.3354 31.72Z" fill="#BCBCC2" />
                  <path d="M31.98 36.529L18.2631 22.1496C16.4188 20.2163 16.447 17.0736 18.458 15.1553L32.9004 1.37823C34.8504 -0.481957 37.9942 -0.480633 39.8962 1.51315L53.5555 15.8321C55.3998 17.7655 55.3715 20.9082 53.3605 22.8265L38.9182 36.6035C36.9648 38.5823 33.8243 38.4624 31.98 36.529Z" fill="#BCBCC2" />
                </g>
                <path class="svgStroke--secondary" d="M35 16L27.5 22.8182L20 16" stroke="#000" stroke-width="3"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
          </div>

          <div class="radioSelectionBox radioSelectionBox--smallP">
            <div class="radioSelectionBox__item radioSelectionBox__item--icon">
              <label pRipple class="radioButtonBox" [for]="option['codigoQR']">
                <i class="radioButtonBox__icon">
                  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18.9636 17.9557V9.96176C18.9636 9.41203 18.5285 8.95387 17.9558 8.95387H9.98475C9.41215 8.95387 8.97687 9.41203 8.97687 9.96176V17.9557C8.97687 18.5055 9.41215 18.9406 9.98475 18.9406H17.9558C18.5285 18.9406 18.9636 18.5055 18.9636 17.9557ZM22.9263 10.9467H28.9275V16.9478H22.9263V10.9467ZM27.1867 15.2071V12.7104H24.69V15.2071H27.1867ZM15.2301 15.2071V12.7104H12.7104V15.2071H15.2301ZM10.9697 22.9262H16.9708V28.9273H10.9697V22.9262ZM30.6225 23.705V21.2083H28.1258V23.705H30.6225ZM23.728 23.705V21.2083H21.2313V23.705H23.728ZM15.2301 27.1636V24.6669H12.7104V27.1636H15.2301ZM27.1867 27.1636V24.6669H24.667V27.1636H27.1867ZM23.728 30.6223V28.1257H21.2313V30.6223H23.728ZM30.6225 30.6223V28.1257H28.1258V30.6223H30.6225ZM30.9203 17.9557V9.96176C30.9203 9.41203 30.485 8.95387 29.9124 8.95387H21.9413C21.3687 8.95387 20.9335 9.41203 20.9335 9.96176V17.9557C20.9335 18.5055 21.3687 18.9406 21.9413 18.9406H29.9124C30.485 18.9406 30.9203 18.5055 30.9203 17.9557ZM10.9697 10.9467H16.9708V16.9478H10.9697V10.9467ZM18.9636 29.9122V21.9184C18.9636 21.3686 18.5285 20.9335 17.9558 20.9335H9.98475C9.41215 20.9335 8.97687 21.3686 8.97687 21.9184V29.9122C8.97687 30.4621 9.41215 30.9201 9.98475 30.9201H17.9558C18.5285 30.9201 18.9636 30.4621 18.9636 29.9122Z" fill="#0046AD"/>
                    <path d="M27.7578 39.9311H33.3468C38.3825 39.9311 40 38.3136 40 33.3466V27.7577C40 26.5437 39.8749 25.8794 38.6837 25.8794C37.4926 25.8794 37.3042 26.5437 37.3042 27.7577V33.1633C37.3042 36.157 36.2259 37.2353 33.3009 37.2353H27.7578C26.5438 37.2353 25.8795 37.4237 25.8795 38.6148C25.8795 39.7829 26.5438 39.9311 27.7578 39.9311Z" fill="#0046AD"/>
                    <path d="M27.7578 0H33.3468C38.3825 0 40 1.61748 40 6.58454V12.1734C40 13.3874 39.8749 14.0517 38.6837 14.0517C37.4926 14.0517 37.3042 13.3874 37.3042 12.1734V6.76778C37.3042 3.77411 36.2259 2.69579 33.3009 2.69579H27.7578C26.5438 2.69579 25.8795 2.50737 25.8795 1.31634C25.8795 0.148177 26.5438 0 27.7578 0Z" fill="#0046AD"/>
                    <path d="M12.2422 39.9311H6.65325C1.61748 39.9311 0 38.3136 0 33.3466V27.7577C0 26.5437 0.125113 25.8794 1.31634 25.8794C2.50737 25.8794 2.69579 26.5437 2.69579 27.7577V33.1633C2.69579 36.157 3.77411 37.2353 6.69908 37.2353H12.2422C13.4562 37.2353 14.1205 37.4237 14.1205 38.6148C14.1205 39.7829 13.4562 39.9311 12.2422 39.9311Z" fill="#0046AD"/>
                    <path d="M12.2422 0H6.65325C1.61748 0 0 1.61748 0 6.58454V12.1734C0 13.3874 0.125113 14.0517 1.31634 14.0517C2.50737 14.0517 2.69579 13.3874 2.69579 12.1734V6.76778C2.69579 3.77411 3.77411 2.69579 6.69908 2.69579H12.2422C13.4562 2.69579 14.1205 2.50737 14.1205 1.31634C14.1205 0.148177 13.4562 0 12.2422 0Z" fill="#0046AD"/>
                  </svg>
                </i>
                <p-radioButton name="paymentOption" [(ngModel)]="selectedOption" [value]="option['codigoQR']" [inputId]="option['codigoQR']"></p-radioButton>
                <span class="radioButtonBox__text">Escanear <strong>código QR</strong></span>
              </label>
            </div>

            <div class="radioSelectionBox__item radioSelectionBox__item--icon">
              <label pRipple class="radioButtonBox" [for]="option['documentoIdentidad']">
                <i class="radioButtonBox__icon radioButtonBox__icon--big ptc-3">
                  <svg width="46" height="36" viewBox="0 0 46 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M23.3578 8.27106C22.7543 8.27106 22.2573 8.76803 22.2573 9.3715C22.2573 9.97497 22.7543 10.4719 23.3578 10.4719H36.4211C37.0245 10.4719 37.5215 9.97497 37.5215 9.3715C37.5215 8.76803 37.0245 8.27106 36.4211 8.27106H23.3578Z" fill="#0046AD"/>
                    <path d="M2.27188 27.582V3.62081C2.27188 2.83985 2.91085 2.23638 3.65631 2.23638H39.2254C40.0064 2.23638 40.6098 2.87535 40.6098 3.62081V13.2053H42.8462V3.62081C42.8462 1.59741 41.2133 0 39.2254 0H3.62081C1.63291 0 0 1.63291 0 3.62081V27.5465C0 29.5699 1.63291 31.1673 3.62081 31.1673H19.3465V28.931H3.6918C2.91084 28.9665 2.27188 28.3275 2.27188 27.582Z" fill="#0046AD"/>
                    <path d="M30.9898 13.7733C30.9898 13.1698 30.4929 12.6728 29.8894 12.6728H23.3578C22.7543 12.6728 22.2573 13.1698 22.2573 13.7733C22.2573 14.3767 22.7188 14.9092 23.3578 14.9092H29.8894C30.4929 14.9092 30.9898 14.4122 30.9898 13.7733Z" fill="#0046AD"/>
                    <path d="M16.2226 16.0806C18.0685 14.9802 19.2045 12.9923 19.2045 10.8624C19.2045 7.4901 16.4711 4.72125 13.0633 4.72125C9.65548 4.72125 6.92213 7.4901 6.92213 10.8624C6.92213 12.9923 8.09357 15.0157 9.93947 16.1161C7.4546 16.9681 5.39571 18.743 4.22427 21.1214C4.08228 21.4054 3.8338 22.2218 3.8338 22.8253C3.90479 25.0262 5.18272 26.3751 7.24161 26.4816H18.3525C18.956 26.4816 20.9439 26.3751 21.9378 24.9197C22.5768 23.9967 22.6123 22.7543 22.0443 21.2989C21.1214 18.885 18.9205 16.9326 16.2226 16.0806ZM13.1343 17.8201C16.2226 17.8201 18.9915 19.5595 19.9854 22.1153C20.2694 22.7898 20.3404 23.3578 20.1274 23.6417C19.8079 24.1032 18.8495 24.2452 18.388 24.2452H7.34811C6.95763 24.2097 6.17667 24.1742 6.10567 22.7543C6.10567 22.6478 6.21217 22.2218 6.24767 22.1153C7.5611 19.453 10.188 17.8201 13.1343 17.8201ZM9.19401 10.8624C9.19401 8.69704 10.9334 6.95763 13.0633 6.95763C15.1932 6.95763 16.9326 8.69704 16.9326 10.8269C16.9326 12.9568 15.1932 14.6962 13.0633 14.6962C10.9334 14.6962 9.19401 12.9923 9.19401 10.8624Z" fill="#0046AD"/>
                    <path d="M30.2748 27.1341C31.2468 28.1061 32.427 28.5921 33.8156 28.5921C35.2041 28.5921 36.3844 28.1061 37.3563 27.1341C38.3283 26.1621 38.8143 24.9819 38.8143 23.5933C38.8143 22.2048 38.3283 21.0245 37.3563 20.0525C36.3844 19.0806 35.2041 18.5946 33.8156 18.5946C32.427 18.5946 31.2468 19.0806 30.2748 20.0525C29.3028 21.0245 28.8168 22.2048 28.8168 23.5933C28.8168 24.9819 29.3028 26.1621 30.2748 27.1341ZM40.4806 28.5921L46 34.1115L44.3338 35.7778L38.8143 30.2583V29.3731L38.5019 29.0607C37.1828 30.2063 35.6207 30.779 33.8156 30.779C31.8022 30.779 30.0838 30.0848 28.6606 28.6962C27.272 27.3077 26.5778 25.6067 26.5778 23.5933C26.5778 21.5799 27.272 19.879 28.6606 18.4904C30.0838 17.0672 31.8022 16.3556 33.8156 16.3556C35.8289 16.3556 37.5299 17.0672 38.9184 18.4904C40.307 19.879 41.0013 21.5799 41.0013 23.5933C41.0013 24.3223 40.8277 25.1554 40.4806 26.0927C40.1334 26.9953 39.7342 27.7242 39.2829 28.2797L39.5954 28.5921H40.4806Z" fill="#0046AD"/>
                  </svg>
                </i>
                <p-radioButton name="paymentOption" [(ngModel)]="selectedOption" [value]="option['documentoIdentidad']" [inputId]="option['documentoIdentidad']"></p-radioButton>
                <span class="radioButtonBox__text">Introducir <strong>documento de identidad</strong></span>
              </label>
            </div>

            <div class="radioSelectionBox__item radioSelectionBox__item--icon">
              <label pRipple class="radioButtonBox">
                <i class="radioButtonBox__icon ptc-3">
                  <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M30.8496 7.4937e-05H10.6038C10.0554 -0.00316257 9.51174 0.0985323 9.00385 0.299353C8.49595 0.500174 8.03376 0.796188 7.64366 1.17049C7.25355 1.5448 6.94318 1.99006 6.73027 2.48086C6.51735 2.97167 6.40606 3.49839 6.40275 4.03096V8.20933H3.41649C2.51038 8.20933 1.64138 8.55891 1.00067 9.18118C0.35995 9.80345 0 10.6474 0 11.5274V30.6742C0 31.8215 0.469268 32.9217 1.30457 33.733C2.13987 34.5442 3.27279 35 4.45409 35H30.8496C31.9483 34.9936 33.0001 34.5668 33.777 33.8123C34.554 33.0577 34.9934 32.0362 35 30.9691V3.93265C34.9672 2.88275 34.5163 1.88615 33.7422 1.15265C32.9681 0.419144 31.9311 0.00595899 30.8496 7.4937e-05ZM2.53073 11.5274C2.53073 11.2993 2.62405 11.0805 2.79016 10.9191C2.95627 10.7578 3.18157 10.6672 3.41649 10.6672H6.40275V30.7725C6.40275 31.2712 6.19878 31.7494 5.8357 32.102C5.47263 32.4546 4.9802 32.6527 4.46674 32.6527C3.95328 32.6527 3.46085 32.4546 3.09777 32.102C2.7347 31.7494 2.53073 31.2712 2.53073 30.7725V11.5274ZM32.4693 30.9691C32.4693 31.3863 32.2986 31.7864 31.9949 32.0814C31.6911 32.3764 31.2792 32.5421 30.8496 32.5421H8.47795C8.77358 31.9611 8.92934 31.3223 8.93348 30.6742V4.03096C8.93348 3.61377 9.10412 3.21367 9.40787 2.91866C9.71161 2.62366 10.1236 2.45793 10.5531 2.45793H30.799C31.2285 2.45793 31.6405 2.62366 31.9443 2.91866C32.248 3.21367 32.4187 3.61377 32.4187 4.03096L32.4693 30.9691Z" fill="#0046AD"/>
                    <path d="M26.9047 26.0042H16.5287C16.1931 26.0042 15.8713 26.1337 15.634 26.3642C15.3967 26.5946 15.2633 26.9072 15.2633 27.2332C15.2633 27.5591 15.3967 27.8717 15.634 28.1021C15.8713 28.3326 16.1931 28.4621 16.5287 28.4621H26.9047C27.2403 28.4621 27.5621 28.3326 27.7994 28.1021C28.0367 27.8717 28.1701 27.5591 28.1701 27.2332C28.1701 26.9072 28.0367 26.5946 27.7994 26.3642C27.5621 26.1337 27.2403 26.0042 26.9047 26.0042Z" fill="#0046AD"/>
                    <path d="M23.8716 14.9825C25.3218 14.1538 26.2143 12.6569 26.2143 11.0531C26.2143 8.51371 24.0668 6.42874 21.3895 6.42874C18.7121 6.42874 16.5647 8.51371 16.5647 11.0531C16.5647 12.6569 17.485 14.1806 18.9352 15.0092C16.983 15.6507 15.3655 16.9873 14.4451 18.7782C14.3336 18.992 14.1383 19.6068 14.1383 20.0612C14.1941 21.7185 15.1981 22.7343 16.8157 22.8145H25.5449C26.019 22.8145 27.5808 22.7343 28.3617 21.6383C28.8637 20.9433 28.8916 20.0078 28.4454 18.9118C27.7203 17.0942 25.9911 15.624 23.8716 14.9825ZM21.4452 16.2923C23.8716 16.2923 26.0469 17.602 26.8278 19.5266C27.0509 20.0345 27.1067 20.4622 26.9394 20.676C26.6884 21.0235 25.9354 21.1305 25.5728 21.1305H16.8994C16.5926 21.1037 15.979 21.077 15.9232 20.0078C15.9232 19.9276 16.0069 19.6068 16.0348 19.5266C17.0667 17.5219 19.1305 16.2923 21.4452 16.2923ZM18.3496 11.0531C18.3496 9.42255 19.7161 8.11276 21.3895 8.11276C23.0628 8.11276 24.4294 9.42255 24.4294 11.0264C24.4294 12.6302 23.0628 13.94 21.3895 13.94C19.7161 13.94 18.3496 12.6569 18.3496 11.0531Z" fill="#0046AD"/>
                  </svg>
                </i>
                <p-radioButton name="paymentOption" [(ngModel)]="selectedOption" [value]="option['listarSolicitudes']" [inputId]="option['listarSolicitudes']"></p-radioButton>
                <span class="radioButtonBox__text">Listado de <strong>solicitudes</strong></span>
              </label>
            </div>
          </div>
        </article>

        <footer>
          <div class="footer__content">
            <button pButton pRipple label="Continuar" icon="pi pi-angle-right" iconPos="right" class="p-button-primary p-button-raised p-button-rounded w-full" [disabled]="!selectedOption" (click)="onContinue()"></button>
          </div>
        </footer>
      </div>
    </ng-container>

    <ng-container *ngIf="stepRequest">
      <div class="sectionContainer fadeinright animation-duration-200">
        <article class="align__top">
          <app-sales-breadcrumbs [routes]="routesBreadcrumbs"></app-sales-breadcrumbs>
          <div class="mainInfo">
            <h1>Listado de solicitudes</h1>
            <p *ngIf="requests.length > 0">
              Seleccioná una solicitud para continuar con el proceso de gestión del cliente.
            </p>
          </div>

          <div class="backgroundArrow">
            <div class="arrowSvg">
              <svg width="55" height="39" viewBox="0 0 55 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g opacity="0.5">
                  <path d="M29.4555 16.4348L18.4474 4.89504C16.9489 3.32418 14.4589 3.27616 12.8745 4.78756L1.23526 15.8906C-0.349133 17.402 -0.418519 19.8915 1.07997 21.4624L12.0881 33.0021C13.5866 34.573 16.0766 34.621 17.661 33.1096L29.3002 22.0066C30.8846 20.4952 30.954 18.0057 29.4555 16.4348ZM16.3354 31.72C15.5432 32.4757 14.2389 32.4505 13.4897 31.6651L2.48155 20.1253C1.73231 19.3399 1.76865 18.0359 2.56085 17.2802L14.2001 6.17717C14.9923 5.42146 16.2966 5.44662 17.0458 6.23205L28.054 17.7718C28.8032 18.5572 28.7669 19.8613 27.9747 20.617L16.3354 31.72Z" fill="#BCBCC2" />
                  <path d="M31.98 36.529L18.2631 22.1496C16.4188 20.2163 16.447 17.0736 18.458 15.1553L32.9004 1.37823C34.8504 -0.481957 37.9942 -0.480633 39.8962 1.51315L53.5555 15.8321C55.3998 17.7655 55.3715 20.9082 53.3605 22.8265L38.9182 36.6035C36.9648 38.5823 33.8243 38.4624 31.98 36.529Z" fill="#BCBCC2" />
                </g>
                <path class="svgStroke--secondary" d="M35 16L27.5 22.8182L20 16" stroke="#000" stroke-width="3"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
          </div>


          <div class="requestList">
            <div class="requestList__content">
              <div class="requestList__tabs">
                <p-tabView>
                  <p-tabPanel [header]="'En la tienda (' + storeRequestsCount + ')'">
                    <p-accordion class="w-full" expandIcon="pi pi-chevron-down" collapseIcon="pi pi-chevron-up">
                      <p-accordionTab *ngFor="let request of storeRequests" iconPos="end" (click)="onSelectAndContinueRequest(request)">
                        <ng-template pTemplate="header">
                          <div class="accordion-header">
                            <div class="requestList__clientInfo">
                              <div class="img">
                                <ng-container *ngIf="request.person.photo_url; else defaultAvatar">
                                  <div class="img__photo" [ngStyle]="{'background-image': 'url(' + request.person.photo_url + ')'}"></div>
                                </ng-container>
                                <ng-template #defaultAvatar>
                                  <div class="img__avatar">
                                    <i class="pi pi-user"></i>
                                  </div>
                                </ng-template>
                              </div>
                              <div class="info">
                                <h2>{{ request.person.first_name.toLowerCase() | lowercase  }} {{ request.person.last_name | lowercase }}</h2>
                                <p>{{ request.person.document_id_number }}</p>
                              </div>
                              <div class="arrow">
                                <i class="pi pi-chevron-down"></i>
                              </div>
                            </div>
                          </div>
                        </ng-template>

                        <ng-template pTemplate="content">
                          <div class="requestList__clientDetails">
                            <div class="requestList__clientDetailsTop">
                              <ul>
                                <li>
                                  <div class="icon">
                                    <i class="pi pi-user"></i>
                                  </div>
                                  <div class="text">
                                    <p><strong>Cliente:</strong> {{ request.person.number }}</p>
                                  </div>
                                </li>
                                <li>
                                  <div class="icon">
                                    <i class="pi pi-file"></i>
                                  </div>
                                  <div class="text">
                                    <p><strong>Solicitud:</strong> {{ request.number }}</p>
                                  </div>
                                </li>
                                <li>
                                  <div class="icon">
                                    <i class="pi pi-calendar"></i>
                                  </div>
                                  <div class="text">
                                    <p><strong>Fecha de solicitud:</strong> {{ request.created_at | date:'dd/MM/yy, h:mm a' }}</p>
                                  </div>
                                </li>
                                <li>
                                  <div class="icon">
                                    <i class="pi pi-phone"></i>
                                  </div>
                                  <div class="text">
                                    <p><strong>Teléfono:</strong> {{ request.person.phone }}</p>
                                  </div>
                                </li>
                              </ul>
                            </div>

                            <div class="requestList__clientDetailsBottom">
                              <ul>
                                <li>
                                  <div class="text">
                                    <p><strong>Estado de contrato:</strong></p>
                                  </div>
                                  <div class="status">
                                    <span>{{ request.agreement.status | lowercase }}</span>
                                  </div>
                                </li>
                                <li>
                                  <div class="text">
                                    <p><strong>Estado de solicitud:</strong></p>
                                  </div>
                                  <div class="status">
                                    <span [class.rejected]="request.status?.toUpperCase() === 'NO APROBADO'">{{ request.status | lowercase }}</span>
                                  </div>
                                </li>
                              </ul>
                            </div>
                            <div class="requestList__clientDetailsBtn" *ngIf="request.agreement.status !== AgreementStatus.FIRMADO">
                              <button pButton pRipple label="Seleccionar" class="p-button-secondary p-button-raised p-button-rounded n-background n-shadow min-pad w-full" (click)="goToDetail(request)"
                                      *ngIf="visibleSelectRequestButton(request)"></button>
                              <div class="requestList__clientDetailsCancel pt-10" *ngIf="request.agreement.status !== AgreementStatus.FIRMADO">
                                <app-sales-cancel-request [requestIncompletedId]="request.id" [isNavigate]="false" [reloadOnCancel]="true"></app-sales-cancel-request>
                              </div>
                            </div>
                          </div>
                        </ng-template>
                      </p-accordionTab>

                      <div class="requestList__emptyState" *ngIf="storeRequests.length === 0">
                        <p>No hay solicitudes disponibles en la tienda.</p>
                      </div>
                    </p-accordion>
                  </p-tabPanel>

                  <p-tabPanel [header]="'A domicilio (' + homeRequestsCount + ')'">
                    <p-accordion class="w-full" expandIcon="pi pi-chevron-down" collapseIcon="pi pi-chevron-up">
                      <p-accordionTab *ngFor="let request of homeRequests" iconPos="end">
                        <ng-template pTemplate="header">
                          <div class="accordion-header">
                            <div class="requestList__clientInfo">
                              <div class="img">
                                <ng-container *ngIf="request.person.photo_url; else defaultAvatar2">
                                  <div class="img__photo" [ngStyle]="{'background-image': 'url(' + request.person.photo_url + ')'}"></div>
                                </ng-container>
                                <ng-template #defaultAvatar2>
                                  <div class="img__avatar">
                                    <i class="pi pi-user"></i>
                                  </div>
                                </ng-template>
                              </div>
                              <div class="info">
                                <h2>{{ request.person.first_name.toLowerCase() | lowercase  }} {{ request.person.last_name | lowercase }}</h2>
                                <p>{{ request.person.document_id_number }}</p>
                              </div>
                              <div class="arrow">
                                <i class="pi pi-chevron-down"></i>
                              </div>
                            </div>
                          </div>
                        </ng-template>

                        <ng-template pTemplate="content">
                          <div class="requestList__clientDetails">
                            <div class="requestList__clientDetailsTop">
                              <ul>
                                <li>
                                  <div class="icon">
                                    <i class="pi pi-user"></i>
                                  </div>
                                  <div class="text">
                                    <p><strong>Cliente:</strong> {{ request.person.number }}</p>
                                  </div>
                                </li>
                                <li>
                                  <div class="icon">
                                    <i class="pi pi-file"></i>
                                  </div>
                                  <div class="text">
                                    <p><strong>Solicitud:</strong> {{ request.number }}</p>
                                  </div>
                                </li>
                                <li>
                                  <div class="icon">
                                    <i class="pi pi-calendar"></i>
                                  </div>
                                  <div class="text">
                                    <p><strong>Fecha de solicitud:</strong> {{ request.created_at | date:'dd/MM/yy, h:mm a' }}</p>
                                  </div>
                                </li>
                                <li>
                                  <div class="icon">
                                    <i class="pi pi-phone"></i>
                                  </div>
                                  <div class="text">
                                    <p><strong>Teléfono:</strong> {{ request.person.phone }}</p>
                                  </div>
                                </li>
                              </ul>
                            </div>

                            <div class="requestList__clientDetailsBottom">
                              <ul>
                                <li>
                                  <div class="text">
                                    <p><strong>Estado de contrato:</strong></p>
                                  </div>
                                  <div class="status">
                                    <span>{{ request.agreement.status | lowercase }}</span>
                                  </div>
                                </li>
                                <li>
                                  <div class="text">
                                    <p><strong>Estado de solicitud:</strong></p>
                                  </div>
                                  <div class="status">
                                    <span [class.rejected]="request.status?.toUpperCase() === 'NO APROBADO'">{{ request.status | lowercase }}</span>
                                  </div>
                                </li>
                              </ul>
                            </div>

                            <div class="requestList__clientDetailsBtn" *ngIf="request.agreement.status !== AgreementStatus.FIRMADO">
                              <button pButton pRipple label="Seleccionar" class="p-button-secondary p-button-raised p-button-rounded n-background n-shadow min-pad w-full" (click)="goToDetail(request)"></button>
                            </div>
                          </div>
                        </ng-template>
                      </p-accordionTab>

                      <div class="requestList__emptyState" *ngIf="homeRequests.length === 0">
                        <p>No hay solicitudes disponibles a domicilio.</p>
                      </div>
                    </p-accordion>
                  </p-tabPanel>
                </p-tabView>
              </div>
            </div>
          </div>
        </article>

        <footer>
          <div class="footer__content">
            <button pButton pRipple label="Volver" icon="pi pi-angle-left" iconPos="left" class="p-button-primary p-button-raised p-button-rounded w-full" (click)="goToHome()"></button>
          </div>
        </footer>
      </div>
    </ng-container>
  </div>
</div>

<p-dialog [(visible)]="visibleQRModal" [modal]="true" [draggable]="false" [resizable]="false" position="bottom" (onHide)="onQRModalClose()">
  <div class="dialog">
    <div class="container">
      <div class="wrapper">
        <div class="dialog__info">
          <h2>Autogestión</h2>
          <p>Escanea el <strong>código QR</strong> proporciado por el cliente</p>
        </div>
        <span class="" *ngIf="hasError()" style="text-align: center;display: block;">
          <small class="p-error">{{ errorMessage }}</small>
        </span>
        <div class="dialog__form smallPadTop">
          <div class="qrScan">
            <div class="loading-indicator">
              <p-progressSpinner></p-progressSpinner>
            </div>
            <div class="qrScan__region">
              <div class="limits">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M22.5 -6.55671e-08C23.3284 -2.93554e-08 24 0.671573 24 1.5C24 2.32843 23.3284 3 22.5 3L1.5 3C0.671574 3 -1.01779e-07 2.32843 -6.55671e-08 1.5C-2.93554e-08 0.671572 0.671574 -1.01972e-06 1.5 -9.83506e-07L22.5 -6.55671e-08Z" fill="white"/>
                  <path d="M-6.55671e-08 1.5C-2.93554e-08 0.671572 0.671574 -1.01972e-06 1.5 -9.83506e-07C2.32843 -9.83506e-07 3 0.671572 3 1.5L3 22.5C3 23.3284 2.32843 24 1.5 24C0.671573 24 8.87631e-07 23.3284 9.23842e-07 22.5L-6.55671e-08 1.5Z" fill="white"/>
                </svg>
              </div>
              <div class="limits">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M22.5 -6.55671e-08C23.3284 -2.93554e-08 24 0.671573 24 1.5C24 2.32843 23.3284 3 22.5 3L1.5 3C0.671574 3 -1.01779e-07 2.32843 -6.55671e-08 1.5C-2.93554e-08 0.671572 0.671574 -1.01972e-06 1.5 -9.83506e-07L22.5 -6.55671e-08Z" fill="white"/>
                  <path d="M-6.55671e-08 1.5C-2.93554e-08 0.671572 0.671574 -1.01972e-06 1.5 -9.83506e-07C2.32843 -9.83506e-07 3 0.671572 3 1.5L3 22.5C3 23.3284 2.32843 24 1.5 24C0.671573 24 8.87631e-07 23.3284 9.23842e-07 22.5L-6.55671e-08 1.5Z" fill="white"/>
                </svg>
              </div>
              <div class="limits">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M22.5 -6.55671e-08C23.3284 -2.93554e-08 24 0.671573 24 1.5C24 2.32843 23.3284 3 22.5 3L1.5 3C0.671574 3 -1.01779e-07 2.32843 -6.55671e-08 1.5C-2.93554e-08 0.671572 0.671574 -1.01972e-06 1.5 -9.83506e-07L22.5 -6.55671e-08Z" fill="white"/>
                  <path d="M-6.55671e-08 1.5C-2.93554e-08 0.671572 0.671574 -1.01972e-06 1.5 -9.83506e-07C2.32843 -9.83506e-07 3 0.671572 3 1.5L3 22.5C3 23.3284 2.32843 24 1.5 24C0.671573 24 8.87631e-07 23.3284 9.23842e-07 22.5L-6.55671e-08 1.5Z" fill="white"/>
                </svg>
              </div>
              <div class="limits">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M22.5 -6.55671e-08C23.3284 -2.93554e-08 24 0.671573 24 1.5C24 2.32843 23.3284 3 22.5 3L1.5 3C0.671574 3 -1.01779e-07 2.32843 -6.55671e-08 1.5C-2.93554e-08 0.671572 0.671574 -1.01972e-06 1.5 -9.83506e-07L22.5 -6.55671e-08Z" fill="white"/>
                  <path d="M-6.55671e-08 1.5C-2.93554e-08 0.671572 0.671574 -1.01972e-06 1.5 -9.83506e-07C2.32843 -9.83506e-07 3 0.671572 3 1.5L3 22.5C3 23.3284 2.32843 24 1.5 24C0.671573 24 8.87631e-07 23.3284 9.23842e-07 22.5L-6.55671e-08 1.5Z" fill="white"/>
                </svg>
              </div>
            </div>
            <div id="reader" *ngIf="isScanning"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-dialog>

<p-dialog [(visible)]="visibleDocumentModal" [modal]="true" [draggable]="false" [resizable]="false" position="bottom">
  <div class="dialog">
    <form [formGroup]="form" (ngSubmit)="onStartWitchDocument()">
      <div class="container">
        <div class="wrapper">
          <div class="dialog__info">
            <h2>Autogestión</h2>
            <p>Introduce el documento de identidad</p>
          </div>
          <div class="dialog__form smallPadTop">
            <div class="form__group form__group--codeNumber fWidth nMarginBot" [ngClass]="{'form__error': ( isSubmitted() || f['document'].touched || f['document'].dirty) && f['document']?.errors}">
              <input pInputText type="text" formControlName="document" onlyAllowedCharacters (input)="onViewError($event)">
              <span class="form__msgError" *ngIf="( isSubmitted() || f['document'].touched || f['document'].dirty) && f['document']?.errors">
                <small class="p-error" *ngIf="f['document'].hasError('required')">{{ "Documento" | required }}</small>
              </span>
              <span class="form__msgError" *ngIf="hasError() && !(f['document'].hasError('required'))">
                <small class="p-error">{{ errorMessage }}</small>
              </span>
            </div>
          </div>
          <div class="dialog__btn pt-35">
            <button pButton pRipple label="Buscar" type="submit" icon="pi pi-search" iconPos="left" class="p-button-primary p-button-raised p-button-rounded w-full" [disabled]="form.invalid" [loading]="isLoading()"></button>
          </div>
        </div>
      </div>
    </form>
  </div>
</p-dialog>
